module.exports = __webpack_public_path__ + "index_pc/img/a2.1c22a7c2.png";